var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 6h-14v36h8v-12h6c6.63 0 12-5.37 12-12s-5.37-12-12-12zm.4 16h-6.4v-8h6.4c2.21 0 4 1.79 4 4s-1.79 4-4 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarPark);
export default __webpack_public_path__ + "static/media/carPark.3af7dcf14b2202ac455d21cd1fea3373.svg";
export { ForwardRef as ReactComponent };